import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  BucketMaintenanceEnabledStatus,
  IcebergCompactionEnabledStatus,
  IcebergCompactionJobStatus,
  IcebergSnapshotManagementEnabledStatus,
  IcebergSnapshotManagementJobStatus,
  IcebergUnreferencedFileRemovalEnabledStatus,
  IcebergUnreferencedFileRemovalJobStatus,
  ReplicationDestinationTableBucketARN,
  TableARN,
  TableBucketARN,
  TableBucketEncryptionType,
  TableBucketOwnerAccountID,
  TableBucketSecurityKMSKeyARN,
  TableBucketType,
  TableMetadataLocation,
  TableNames,
  TableNamespaces,
  TableReplicationRole,
  TableReplicationRuleStatus,
} from '../../../../Components/MetadataField/MetaGridFields';

export const S3TableBucketMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        arn="None"
        createdAt={metadata}
        state="None"
        owner="None"
        vpc="None"
        availabilityZone="None"
      />
      {TableBucketType(metadata)}
      {TableARN(metadata)}
      {TableNamespaces(metadata)}
      {TableNames(metadata)}
      {BucketMaintenanceEnabledStatus(metadata)}
      {IcebergCompactionEnabledStatus(metadata)}
      {IcebergSnapshotManagementEnabledStatus(metadata)}
      {IcebergUnreferencedFileRemovalEnabledStatus(metadata)}
      {IcebergCompactionJobStatus(metadata)}
      {IcebergSnapshotManagementJobStatus(metadata)}
      {IcebergUnreferencedFileRemovalJobStatus(metadata)}
      {TableMetadataLocation(metadata)}
      {TableReplicationRole(metadata)}
      {TableReplicationRuleStatus(metadata)}
      {ReplicationDestinationTableBucketARN(metadata)}
      {TableBucketARN(metadata)}
      {TableBucketOwnerAccountID(metadata)}
      {TableBucketEncryptionType(metadata)}
      {TableBucketSecurityKMSKeyARN(metadata)}
    </Grid>
  );
};
